import React, { useEffect } from 'react'

import { useGlobalContext } from 'contexts/global'
import { Feedback } from 'components/Feedback'
import { useAuthorizationContext, useClientContext } from 'contexts'
import { sendSelectContent, sendScreenView } from 'utils'
import { FEEDBACK_STATUS } from 'constants/feedback'

import InterWebviewBridge, { interWbNavigate } from '@interco/inter-webview-bridge'

const iWb = InterWebviewBridge.getInstance()

function getFeedbackStatus({
  isAuthorization,
  status,
}: {
  isAuthorization: boolean
  status: 'successRedirect' | 'successNoRedirect'
}) {
  if (!isAuthorization) {
    return status === 'successRedirect' ? 'accountCreatedRedirect' : 'accountCreatedNoRedirect'
  }
  return status
}

export const SuccessAuth = () => {
  const { client, isAuthorization } = useClientContext()
  const { setHeaderPage, headerPage } = useGlobalContext()
  const { redirectUri } = useAuthorizationContext()

  useEffect(() => {
    setHeaderPage(undefined)
  }, [])

  useEffect(() => {
    if (client && !headerPage) {
      sendScreenView({ scenario: client.name, step: 'success' })
    }
  }, [client, headerPage])

  const onContinue = () => {
    const buttonText = redirectUri
      ? FEEDBACK_STATUS.successRedirect.button
      : FEEDBACK_STATUS.successNoRedirect.button

    sendSelectContent({
      scenario: client?.name ?? 'unidentified',
      step: 'success',
      element_name: buttonText,
      element_type: 'button',
      parent_name: 'success',
    })

    if (redirectUri) {
      iWb.execute({
        action: 'customOpenNativeBrowser',
        metadata: { url: redirectUri },
      })
    }
    interWbNavigate.requestGoBack()
  }

  return (
    <Feedback
      status={getFeedbackStatus({
        status: redirectUri ? 'successRedirect' : 'successNoRedirect',
        isAuthorization,
      })}
      onContinue={onContinue}
    />
  )
}
